import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable()
export class TripEntryService {

    constructor(private dataService: DataService) {
    };

    // get(refresh: Boolean) {
    //     return this.dataService.getData('/api/serviceschedule', refresh);
    // }
    get(data: any, refresh: boolean) {
        return this.dataService.getData('/api/tripentry/' + data.region + '/' + data.division + '/' + data.subdivision +'/'+data.financialYearId, refresh);
    }

    getbyQId(data:any, refresh: Boolean) {
        return this.dataService.getData('/api/tripentry/logs/' + data.vehicleId + '/' +data.startts, refresh);
    }

    // getLookUp(refresh: Boolean) {
    //     return this.dataService.getData('/api/serviceschedule/lookup', refresh);
    // }
    getLookUp(data: any, refresh: Boolean) {
        return this.dataService.getDataWithParams('/api/serviceschedule/lookup/', data, refresh);
    }
    getById(id: number) {
        return this.dataService.getRecord('/api/tripentry/' + id);
    }

    delete(id: number) {
        return this.dataService.delete('/api/tripentry/' + id).map(response => {
            this.dataService.clearCache();
            // this.dataService.clearRouteCache(this.route);
            return response;
        });
    }
    // delete(id: number) {
    //     return this.dataService.post('/api/region/delete/' + id, null).map(response => {
    //         this.dataService.clearRouteCache(this.getEventRoute);
    //         return response;
    //     });
    // }
    save(data: any) {
        // const split = data.totalHrs.split(':');
        // if (split && split.length > 0)
        //     data.totalHrs = (parseInt(split[0]) * 60) + parseInt(split[1]);

        if (data.uomType !== 3) {
            const splitchargableUnits = data.totalRevenueHrs.split(':');
            if (splitchargableUnits && splitchargableUnits.length > 0)
                data.totalRevenueHrs = (parseInt(splitchargableUnits[0]) * 60) + parseInt(splitchargableUnits[1]);
        } else {
            data.totalRevenueHrs = parseInt(data.totalRevenueHrs);
        }
        if (data.uomType !== 3 && data.totalNonRevenueHrs) {
            const splitchargableUnits = data.totalNonRevenueHrs.split(':');
            if (splitchargableUnits && splitchargableUnits.length > 0)
                data.totalNonRevenueHrs = (parseInt(splitchargableUnits[0]) * 60) + parseInt(splitchargableUnits[1]);
        } else {
            data.totalNonRevenueHrs = parseInt(data.totalNonRevenueHrs);
        }
        
        const splitutilizedHrs = data.utilizedHrs.split(':');
        if (splitutilizedHrs && splitutilizedHrs.length > 0)
            data.utilizedHrs = (parseInt(splitutilizedHrs[0]) * 60) + parseInt(splitutilizedHrs[1]);


        // if(data.tripRevenueImplementViewModels && data.tripRevenueImplementViewModels.length > 0){
        //     data.tripRevenueImplementViewModels.forEach(element => {
        //         let totalhourssplit = element.totalhours.split(':');
        //         if(totalhourssplit && totalhourssplit.length > 0)
        //         element.totalhours = (parseInt(split[0]) * 60) + parseInt(split[1]);
        //     });
            
        // }


        // const splitbreakHrs = data.breakHrs.split(':');
        // if (splitbreakHrs && splitbreakHrs.length > 0)
        //     data.breakHrs = (parseInt(splitbreakHrs[0]) * 60) + parseInt(splitbreakHrs[1]);



        //    data.totalHrs =  data.totalHrs.toString();
        //    data.chargableUnits =  data.chargableUnits.toString();
        //    data.utilizedHrs =  data.utilizedHrs.toString();
        //    data.breakHrs =  data.breakHrs.toString();

        //   if(data.hh && data.mm)
        //    data.breakHrs = (parseInt(data.hh) * 60) + parseInt(data.mm);

        //    const split = data.totalHrs.split(':');
        //    if(split && split.length > 0)
        //    data.totalHrs = (parseInt(split[0]) * 60) + parseInt(split[1]);

        
        return this.dataService.post('/api/tripentry', data).map(response => {
            return response;
        });
    }

    getPrioritys(refresh: boolean) {

        return this.dataService.getData('/api/lookup/prioritytype', refresh);
    }
    getMaintenanceType(refresh: boolean) {

        return this.dataService.getData('/api/lookup/maintenancetype', refresh);
    }

    getUomType(refresh: boolean) {
        return this.dataService.getData('/api/lookup/uomtype', refresh);
    }
    getMachineType(refresh: boolean) {
        return this.dataService.getData('/api/lookup/machinetype', refresh);
    }
    getVehicleTypeLookup(refresh: boolean) {
        return this.dataService.getData('/api/lookup/vehicletype', refresh);
    }
    getRevenueType(refresh: boolean) {
        return this.dataService.getData('/api/lookup/revenuetype', refresh);
    }
    saveTripSimulate(data: any) {
        return this.dataService.post('/api/tripentry/tripsimulate', data).map(response => {
            return response;
        });
    }

    trackingInfo(query: any, refresh: boolean) {
        return this.dataService.getData('/api/tripentry/trackinghistory/' + query.vehicleId + '/' + query.start + '/' + query.end, refresh);
    }

    getTariff(id: number, refresh: boolean) {
        return this.dataService.getData('/api/tariff/vehicletype/' + id, refresh);
    }

    getTariffData(id: number, date, refresh: boolean) {
        return this.dataService.getData('/api/tariff/' + id + '/' + date, refresh);
    }

    getApprove(id: any) {
        return this.dataService.post('/api/tripentry/approve', id).map(response => {
            return response;
        });
    }

}
